import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

import {
  OperdayErrorsErrorType,
  OperdayErrorsIssueDto,
  OperdayErrorsObjectType,
  OperdayErrorsProblemArea,
  OperdayErrorsSourceOfficeType,
} from "../../../dto/OperdayErrors/OperdayErrorsDto";
import SortObject from "../../../types/SortObject";

export type OperdayErrorsFilters = {
  date: string;
  companyIds?: Array<number>;
  problemArea?: OperdayErrorsProblemArea;
  objectType?: OperdayErrorsObjectType;
  errorType?: OperdayErrorsErrorType;
  fixed?: boolean;
};

const initialState: {
  loading: boolean;
  rebuilding: boolean;
  issues: Array<OperdayErrorsIssueDto>;
  total: number;
  page: number;
  pageSize: number;
  sort?: SortObject;
  filters: OperdayErrorsFilters;
} = {
  loading: false,
  rebuilding: false,
  issues: [],
  total: 0,
  page: 1,
  pageSize: 20,
  filters: {
    date: dayjs().format("YYYY-MM-DD"),
  },
};

const operdayErrorsSlice = createSlice({
  name: "operdayErrors",
  initialState,
  reducers: {
    load(state) {
      state.loading = true;
    },
    loadSuccess(state, action: PayloadAction<{ issues: Array<OperdayErrorsIssueDto>; total: number }>) {
      state.loading = false;
      state.issues = action.payload.issues;
      state.total = action.payload.total;
    },
    loadReject(state) {
      state.loading = false;
    },
    changeFilters(state, action: PayloadAction<Partial<OperdayErrorsFilters>>) {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 1;
      state.loading = true;
    },
    changeTable(
      state,
      action: PayloadAction<{
        page: number;
        pageSize: number;
        sort?: SortObject;
        filters?: Partial<OperdayErrorsFilters>;
      }>,
    ) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      if (action.payload.filters) {
        state.filters = { ...state.filters, ...action.payload.filters };
      }
      state.loading = true;
    },
    rebuild(state) {
      state.rebuilding = true;
    },
    rebuildSuccess(state) {
      state.rebuilding = false;
    },
    rebuildReject(state) {
      state.rebuilding = false;
    },
    setIssueFixed(
      state,
      _action: PayloadAction<{
        id: number;
        fixed: boolean;
        companyId: number;
        sourceOfficeType?: OperdayErrorsSourceOfficeType;
      }>,
    ) {
      state.loading = true;
    },
    setIssueFixedSuccess(state, action: PayloadAction<OperdayErrorsIssueDto>) {
      state.loading = false;
      state.issues = state.issues.map((issue) => (issue.id === action.payload.id ? action.payload : issue));
    },
    setIssueFixedReject(state) {
      state.loading = false;
    },
  },
});

export default operdayErrorsSlice;
